<template>
    <div id="menu">
        <el-menu
            :default-active="activeMenu"
            :default-openeds="activeMenu1"
            class="el-menu"
            :unique-opened="true"
            :collapse="isCollapse"
            :collapse-transition="false"
            menu-trigger="false"
        >
            <el-submenu index="2">
                <template slot="title">
                    <i class="apply icon"></i>
                    <span slot="title">我要报名</span>
                </template>
                <el-menu-item index="2-2">
                    <router-link :to="{ path: '/register' }">我要报名</router-link>
                </el-menu-item>
                <el-menu-item index="2-3">
                    <router-link :to="{ path: '/pay' }">我要缴费</router-link>
                </el-menu-item>
                <el-menu-item index="2-4">
                    <router-link :to="{ path: '/order' }">我的订单</router-link>
                </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">
                    <i class="class icon"></i>
                    <span slot="title">我的班级</span>
                </template>
                <el-menu-item index="3-1">
                    <router-link :to="{ path: '/myclass' }">已报名班级</router-link>
                </el-menu-item>
                <el-menu-item index="3-2">
                    <router-link :to="{ path: '/Assessment' }">教学评估</router-link>
                </el-menu-item>
                <el-menu-item index="3-3">
                    <router-link :to="{ path: '/attendance' }">考勤管理</router-link>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeMenu: "1-1",
            activeMenu1: [1 - 1],
            // activeMenuopen:[],
            isCollapse: false,
            userAuth: [],
        };
    },
    mounted() {
        this.initLoad();
    },
    methods: {
        //展开菜单
        handleOpen() {
            // this.isCollapse = false;
            this.$global.isCollapse = false;
            this.isCollapse = this.$global.isCollapse;
            let right = document.getElementById("right-wrap");
            right.style.marginLeft = "-202px";
            right.style.paddingLeft = "202px";
        },
        //收起菜单
        handleClose() {
            // this.isCollapse = true;
            this.$global.isCollapse = true;
            this.isCollapse = this.$global.isCollapse;
            let right = document.getElementById("right-wrap");
            right.style.marginLeft = "-82px";
            right.style.paddingLeft = "82px";
        },
        //自适应高度
        initLoad: function () {
            let me = this;
            // me.activeMenuopen=[];
            let menu = document.getElementById("menu");
            let menu_height = me.$global.height - 62;
            menu.style.height = menu_height + "px";
            me.activeMenu = me.$global.activeMenu;
            // me.activeMenuopen.push(me.$global.activeMenu);
            let userAuth = window.sessionStorage.getItem("userAuth");
            userAuth = JSON.parse(userAuth);

            me.userAuth = [];
            if (userAuth) {
                userAuth.forEach((row) => {
                    if (row["type"] == "1") {
                        me.userAuth[row["id"]] = row["name"];
                    } else if (row["type"] == "2") {
                        me.userAuth[row["parentId"]] = row["name"];
                    }
                });
            }
        },
    },
    watch: {
        //监听路由，判断头部和菜单是否显示
        $route(to, from) {
            this.initLoad();
            if (to.name == "parameter") {
                console.log(13);
                this.handleClose();
            }
        },
    },
};
</script>
<style lang="scss">
#left-wrap {
    background-color: #dfe6f8;
    border-right: 1px solid #d9dce2;
    box-shadow: 0 0 3px #d9dce2;
    #menu {
        .el-menu {
            color: #4c5367;
            line-height: 60px;
            background-color: #dfe6f8;
            width: 200px;
            height: 100%;
            position: relative;
            & > .el-menu-item {
                font-size: 16px;
                a,
                a:hover {
                    color: #4c5367;
                    text-decoration: none;
                    width: 200px;
                    margin: 0 -20px;
                    padding: 0 20px;
                    display: inline-block;
                }
            }
            .el-submenu__title span {
                font-size: 16px;
            }
            //激活的二级菜单
            .el-submenu.is-active {
                .el-submenu__title {
                    color: #ffffff;
                    background-color: #418ce2;
                    i {
                        color: #ffffff;
                    }
                }
                .el-menu {
                    background-color: #ffffff;
                    padding-bottom: 0;
                    .el-menu-item.is-active {
                        color: #418ce2;
                        font-weight: bold;
                        background-color: #fff;
                        a,
                        a:hover {
                            color: #418ce2;
                        }
                    }
                }
            }
            & > .el-menu-item.is-active {
                color: #ffffff;
                background-color: #418ce2;
                a,
                a:hover {
                    color: #ffffff;
                }
            }
            //展开的二级菜单
            .el-submenu.is-opened {
                .el-menu {
                    background-color: #ffffff !important;
                    padding-bottom: 0;
                    .el-menu-item {
                        cursor: auto;
                        a,
                        a:hover {
                            color: #4c5367;
                            text-decoration: none;
                            width: 200px;
                            margin: 0 -45px;
                            padding: 0 45px;
                            display: inline-block;
                        }
                    }
                }
            }
            //图标
            .el-menu-item,
            .el-submenu__title {
                i.icon {
                    background-image: url("../../assets/images/icon/desktop.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                    display: inline-block;
                }
                i.customers {
                    background-image: url("../../assets/images/icon/customers.png");
                }
                i.application {
                    background-image: url("../../assets/images/icon/application.png");
                }
                i.finance {
                    background-image: url("../../assets/images/icon/finance.png");
                }
                i.setting {
                    background-image: url("../../assets/images/icon/setting.png");
                }
                i.apply {
                    background-image: url("../../assets/images/icon/apply_icon.png");
                }
                i.class {
                    background-image: url("../../assets/images/icon/class_icon.png");
                }
            }
            .el-menu-item.is-active {
                i.desktop {
                    background-image: url("../../assets/images/icon/desktop_active.png");
                }
            }
            .el-submenu.is-active {
                .el-submenu__title {
                    i.customers {
                        background-image: url("../../assets/images/icon/customers_active.png");
                    }
                    i.application {
                        background-image: url("../../assets/images/icon/application_active.png");
                    }
                    i.finance {
                        background-image: url("../../assets/images/icon/finance_active.png");
                    }
                    i.setting {
                        background-image: url("../../assets/images/icon/setting_active.png");
                    }
                    i.apply {
                        background-image: url("../../assets/images/icon/apply_icon_active.png");
                    }
                    i.class {
                        background-image: url("../../assets/images/icon/class_icon_active.png");
                    }
                }
            }
        }

        //展开收起按钮
        .collape-button {
            text-align: right;
            padding-right: 10px;
            position: absolute;
            right: 0;
            bottom: 0;
            button {
                background-color: #dfe6f8;
                padding: 10px;
                border: none;
                cursor: pointer;
                i {
                    width: 20px;
                    height: 16px;
                    display: inline-block;
                    &.open-menu {
                        background: url("../../assets/images/icon/menu_open.png")
                            no-repeat 0 0;
                    }
                    &.close-menu {
                        background: url("../../assets/images/icon/menu_close.png")
                            no-repeat 0 0;
                    }
                }
            }
        }

        //收起的菜单
        .el-menu--collapse {
            width: 80px !important;
            .el-menu-item,
            .el-submenu {
                text-align: center;
                .submenu .el-menu-item {
                    text-align: left;
                }
            }
            & > .el-menu-item {
                a,
                a:hover {
                    width: 80px;
                }
            }
            .collape-button {
                padding-right: 23px;
            }
        }
    }
}
//收起时的子菜单
.el-menu--vertical {
    .el-menu {
        box-shadow: 0 3px 5px #ccc;
        .el-menu-item {
            line-height: 40px;
            height: 40px;
            a,
            a:hover {
                color: #303133;
                text-decoration: none;
            }
        }
        .is-active {
            font-weight: bold;
            a,
            a:hover {
                color: #418ce2;
                text-decoration: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/left.vue